export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Lists-Gray-463a3ad64efdb496326183899796529b.svg";